
import {
  BuilderElementAttributePropertyPathBased,
  BuilderElementAttributes,
  BuilderElementAttributeTemplated,
  BuilderElementAttributeWithRawValue
} from "@/types/elements";
import Vue from "vue";
import { Component, Inject, Prop } from "vue-property-decorator";
import draggable from "vuedraggable";
import { ElementStudioContext } from "@/components/ElementStudio/ElementStudioTabsAndPanels.vue";
import Accordion from "@/components/UI/Accordion.vue";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import Repeater from "@/components/Reusable/CustomInputs/Repeater/Repeater.vue";
import defensiveCopy from "@/util/defensive-copy";
import CodeInput from "@/components/Reusable/CustomInputs/CodeInput/CodeInput.vue";
import { inputTextValidationRules } from "@/util/input-text-validation-rules";

@Component({
  components: {
    CodeInput,
    Repeater,
    Dropdown,
    Accordion,
    draggable
  }
})
export default class ElementStudioAttributes extends Vue {
  @Prop({ default: () => [] })
  value!: BuilderElementAttributes;

  @Inject("context") readonly context!: ElementStudioContext;

  updateAttributes(newValue: BuilderElementAttributes) {
    this.$emit("input", newValue);
  }

  updateName(index: number, newAttributeName: string) {
    const newValue = defensiveCopy(this.value);

    if (this.htmlAttributeNameRule(newAttributeName) !== true) return;

    newValue[index].name = newAttributeName.trim();
    this.$emit("input", newValue);
  }

  updateTemplateValue(index: number, newTemplate: string | null) {
    const newValue = defensiveCopy(this.value);

    (newValue[index] as BuilderElementAttributeTemplated).template =
      newTemplate ?? "";
    this.$emit("input", newValue);
  }

  updatePropertyPathValue(index: number, newTemplate: string) {
    const newValue = defensiveCopy(this.value);

    (newValue[index] as BuilderElementAttributePropertyPathBased).propertyPath =
      newTemplate;
    this.$emit("input", newValue);
  }

  updateRawValue(index: number, newTemplate: string) {
    const newValue = defensiveCopy(this.value);

    (newValue[index] as BuilderElementAttributeWithRawValue).rawValue =
      newTemplate;
    this.$emit("input", newValue);
  }

  htmlAttributeNameRule(value: string | undefined) {
    return inputTextValidationRules.validateHtmlAttributeName(value);
  }
}
